import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import Lenis from 'lenis';

import { AuthProvider } from './lib/AuthContext';
import { Navigation } from './components/Navigation';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { DimensionsSection } from './components/DimensionsSection';
import { ExperienceSection } from './components/ExperienceSection';
import { BlogSection } from './components/BlogSection';
import { ConnectSection } from './components/ConnectSection';
import { BlogDetailPage } from './pages/BlogDetailPage';
import { BlogIndexPage } from './pages/BlogIndexPage';
import { AdminLoginPage } from './pages/AdminLoginPage';
import { AdminDashboardPage } from './pages/AdminDashboardPage';
import { AdminPostEditorPage } from './pages/AdminPostEditorPage';

function HomePage() {
  return (
    <main className="relative">
      <HeroSection />
      <AboutSection />
      <DimensionsSection />
      <ExperienceSection />
      <BlogSection />
      <ConnectSection />
    </main>
  );
}

function App() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Initialize Lenis smooth scroll
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      smoothTouch: false,
      touchMultiplier: 2,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    // Set loaded after a brief delay for entrance animation
    setTimeout(() => setIsLoaded(true), 100);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <AuthProvider>
      <Router>
        <div className={`min-h-screen bg-background transition-opacity duration-1000 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}>
          <Toaster 
            position="top-right" 
            toastOptions={{
              style: {
                background: '#0A0A0A',
                border: '1px solid rgba(212, 175, 55, 0.3)',
                color: '#E2E2E2',
              },
            }}
          />
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={
              <>
                <Navigation />
                <HomePage />
              </>
            } />
            <Route path="/blog" element={
              <>
                <Navigation />
                <BlogIndexPage />
              </>
            } />
            <Route path="/blog/:id" element={
              <>
                <Navigation />
                <BlogDetailPage />
              </>
            } />
            
            {/* Admin Routes */}
            <Route path="/admin" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
            <Route path="/admin/posts/new" element={<AdminPostEditorPage />} />
            <Route path="/admin/posts/:id" element={<AdminPostEditorPage />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
